export default __webpack_public_path__ + "static/media/stake-more-om-new.97227918.svg";